export default __webpack_public_path__ + "assets/check.f810becf.svg";